// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".69f53d7ca2a2f88739db0b1c2284d1173706fd44.chunk.bundle.js";
};